import { ReactNode } from "react";

import { Navigate, useLocation } from "react-router-dom";

import { useAccount } from "../../../hooks/useAccount";
import { useToken } from "../../../hooks/useToken";

export type TAuthGuardProps = {
	children: ReactNode;
};

export function AuthGuard({ children }: TAuthGuardProps) {
	const { token } = useToken();
	const { account } = useAccount();
	const location = useLocation();

	if (!token) {
		return <Navigate to={`/sign-in?redirect=${location.pathname}`} replace />;
	}

	if (!account) {
		// TODO: I will return a loading later
		return null;
	}

	return <>{children}</>;
}
